<template>
    <div class="ur-data-grid__header" ref="gridHeader" v-grid-click-outside="handler_clickOutside">
        <!-- Row component -->
        <feader-row v-if="!!freezeWidth"/>
        <header-row/>
        <!-- Sub modules -->
        <header-context/>
        <header-config/>
    </div>
</template>


<script>
// [IMPORT] Sub components
import headerRow from "./urDataGridHeaderRow.vue";
import feaderRow from "./urDataGridFeaderRow.vue";

import headerContext from "./module/urDataGridHeaderContext.vue"
import headerConfig  from "./module/urDataGridHeaderConfig.vue"

export default {
    name : 'urDataGridHeader',
    inject : ['gridInfo'],
    components : {headerRow, feaderRow, headerContext, headerConfig},
    computed : {
        freezeWidth() {return this.gridInfo.vars_freezeWidth},
        dataStyle() {return {
            "height": `${this.gridInfo.opts.headerHeight}px`,
            "width" : `calc(100% - ${this.freezeWidth}px)`,
            "margin-left": `${this.freezeWidth}px`
        }},
        freezeStyle() {return {
            "height": `${this.gridInfo.opts.headerHeight}px`,
            "width" : `${this.freezeWidth}px`,
        }},
        dataAdjustStyle() {return {
            'width' : (this.gridInfo.vars_tableWidth-this.gridInfo.vars_freezeWidth)+'px'
        }}
    },
    mounted() {
        this.gridInfo.func.setRefs('header'      ,this.$refs.gridHeader);
    },
    methods : {
        // [METHOD] document click document - click outside
        handler_clickOutside(e) {
            // 1. close header context
            this.gridInfo.func.setHeaderContext(null);
        },
    },
    directives: {
        'grid-click-outside': {
            bind: function(el, binding) {
                // Define Handler and cache it on the element
                const handler = (e) => {
                    if (!(el.contains(e.target) || el === e.target)) {
                        binding.value(e)
                    }
                }
                el.__vueClickOutside__ = handler
                // add Event Listeners
                document.addEventListener('mousedown', handler)
            },
            unbind: function(el, binding) {
                // Remove Event Listeners
                document.removeEventListener('mousedown', el.__vueClickOutside__)
                el.__vueClickOutside__ = null
            }
        }
    }
}
</script>

